var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 3.25,
    width: 23.5,
    height: 17.5,
    rx: 2.75,
    fill: "#F7F7F7",
    stroke: "#C4C4C4",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4282 13.9103L13.1731 14.8606H11.4153C10.8578 14.8606 10.1774 14.6324 9.82778 14.1763C9.47819 13.7204 9.26084 12.8745 9.76166 11.535C10.2625 10.1951 11.4437 9.74835 12.5115 9.74835H14.4205C14.4205 9.74835 14.3731 10.0905 14.2599 10.3184C14.1466 10.5466 13.9954 10.7461 13.6739 10.7461H12.5778C12.228 10.7461 11.5288 10.8028 11.2737 11.5822C11.0184 12.3615 10.9431 12.9696 11.0374 13.3116C11.1319 13.6537 11.4143 13.9009 11.8217 13.9009C12.2292 13.9009 13.4282 13.9103 13.4282 13.9103Z",
    fill: "#0060AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.076 8.00006L16.284 11.4638C16.5907 11.4196 17.094 11.2942 17.5864 10.9363C18.3707 10.3662 18.5503 9.76744 18.5503 9.76744H20.2324C20.2324 9.76744 19.996 10.5559 19.0699 11.2592C18.1438 11.9623 17.4446 12.0765 17.4446 12.0765C17.4446 12.0765 18.1156 12.7415 18.5407 13.3403C18.966 13.9388 19.5709 14.8605 19.5709 14.8605H17.7848C17.7848 14.8605 17.4729 14.2904 16.925 13.5873C16.4952 13.036 16.2805 12.8001 16.0209 12.6138L15.5072 14.8605H14.0992C14.0992 14.8605 15.4978 8.66511 15.564 8.37064C15.6301 8.07598 15.8001 8.00006 15.9419 8.00006H17.076Z",
    fill: "#0060AB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.28351 8.00946L5.00004 9.05471C5.00004 9.05471 6.03699 9.05287 7.21271 9.05082L5.8978 14.8701L7.41925 14.8604L8.74395 9.04795C9.67947 9.04632 10.4427 9.04529 10.5189 9.04529C10.7268 9.04529 10.8591 9.02626 10.9158 8.80751C10.9723 8.58918 11.0668 8.00946 11.0668 8.00946H5.28351Z",
    fill: "#0060AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTck);
export default __webpack_public_path__ + "static/media/tck.ffb7a0d6419b9c54d1f5791526234d69.svg";
export { ForwardRef as ReactComponent };